/* Minimal Lucide stub so theme.liquid's createIcons() doesn't error.
   Replace with real Lucide if needed. */
(function () {
  if (window.lucide) return;
  window.lucide = {
    createIcons: function root(el) {
      var scope = el || document;
      // naive replace of [data-icon] with a simple svg (menu, mail, star, check)
      var map = {
        menu: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M3 12h18M3 18h18"/></svg>',
        mail: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16v16H4z"/><path d="M22 6l-10 7L2 6"/></svg>',
        star: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.6 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z"/></svg>',
        check: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg>'
      };
      scope.querySelectorAll('[data-icon]').forEach(function (n) {
        var name = n.getAttribute('data-icon');
        if (map[name]) n.innerHTML = map[name];
      });
    }
  };
  if (document.readyState === 'complete') window.lucide.createIcons();
  else window.addEventListener('load', function(){ try { window.lucide.createIcons(); } catch(e){} });
})();
